import { render, staticRenderFns } from "./Manage-team.vue?vue&type=template&id=005cd58c&"
import script from "./Manage-team.vue?vue&type=script&lang=js&"
export * from "./Manage-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports